import { render, staticRenderFns } from "./RolesArchive.vue?vue&type=template&id=2c12b5cd&lang=pug&"
import script from "./RolesArchive.vue?vue&type=script&lang=js&"
export * from "./RolesArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports